module.exports = __webpack_public_path__ + "img/Patch12.32f4a730.webp";